import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import ReactDatatable from "@ashvin27/react-datatable";
import { Images } from "../Components/Images";
import InnerFooter from "../Components/InnerFooter";

import { getTransaction } from "../actions/markets";
import { getAccount } from "../Hooks/useAccount";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import DepositModal from "../Modals/DepositModal";
import WithdrawModal from "../Modals/WithdrawModal";
import { UserBalance } from "../Hooks/useWeb3";


const Vault = () => {
  const [showDeposit, setShowDeposit] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [currencyName, setCurrencyName] = useState()

  const handleCloseDeposit = () => setShowDeposit(false);


  const handleShowDeposit = () => setShowDeposit(true);



  const handleShowWithdraw = (record) => {
    setCurrencyName(record);
    setShowWithdraw(true);
  };

  const handleCloseWithdraw = () => { setShowWithdraw(false); setCurrencyName() };


  const user = getAccount();

  const [userData, setUserData] = useState()
  const [bnbBalance, setbnbBalance] = useState()
  const [maticzBalance, setmaticzBalance] = useState()



  const getUserWalletBalance = async (address) => {
    try {
      let { balance1, balance2 } = await UserBalance(address)
      setbnbBalance(balance1)
      setmaticzBalance(balance2)

      console.log("balance2balance2", balance2);

    }
    catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    let userData = sessionStorage.getItem('user')
    userData = JSON.parse(userData)
    console.log("🚀 ~ useEffect ~ userData:", userData)
    setUserData(userData)
    getUserWalletBalance(userData.escrowAddress)
  }, user, [])


  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <div className="common_bgVideo vault_page">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />

        <img
          src={Images.planlftOvly}
          className="opportunity__lftBlur img-fluid"
        />
        <img
          src={Images.planrytOvly}
          className="opportunity__rightBlur img-fluid"
        /> */}
        <Header />
        <Container
          fluid
          className="p-0 custom_container"
        >
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder pb-3 pb-lg-4">
              <h4 className="m-0 hebrew_bold opportunity__title">Vault</h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative mt-2">
                Securely manage your gas balance and payouts in one place.
              </p>
              <div className="dashboard__blueBox mt-5">
                <div className="valut_sec">
                  <div className="card_sec">
                    {/* <div className="deposit_card">
                      <div className="header_sec">
                        <div className="logo">
                          <img src={Images.bnb} className="img_src img-fluid" />
                        </div>
                        <p className="name mb-0">BNB</p>
                      </div>
                      <p className="balance mb-0">
                        Balance: <span className="value">{bnbBalance}</span>
                      </p>
                     
                      <div className="balance_btns">
                        <button
                          className="linear_btn"
                          onClick={handleShowDeposit}
                        >
                          Deposit
                        </button>
                        <button
                          className="linear_btn"
                          onClick={() => handleShowWithdraw('BNB')}
                        >
                          Withdraw
                        </button>
                      </div>
                    </div> */}
                    <div className="deposit_card">
                      <div className="header_sec">
                        <div className="logo">
                          <img
                            src={Images.polygon}
                            className="img_src img-fluid"
                          />
                        </div>
                        <p className="name mb-0">Matic</p>
                      </div>
                      <p className="balance mb-0">
                        Balance: <span className="value">{parseFloat(maticzBalance) > 0 ? maticzBalance : "0"} Matic</span>
                      </p>
                      {/* <input
                        type="text"
                        className="balance__input position-relative hebrew_font w-100 rounded-1"
                        placeholder="Balance"
                      /> */}
                      <div className="balance_btns">
                        <button
                          className="linear_btn"
                          onClick={handleShowDeposit}
                        >
                          Deposit
                        </button>
                        <button
                          className="linear_btn"
                          onClick={() => handleShowWithdraw('MATIC')}
                        >
                          Withdraw
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Container>
      </div>
      <NewFooter />

      {/* modal */}
      {showDeposit && (
        <DepositModal
          show={showDeposit}
          handleClose={handleCloseDeposit}
          userData={userData}
        // handleShow={handleShowPair}
        />
      )}

      {showWithdraw && (
        <WithdrawModal
          show={showWithdraw}
          handleClose={handleCloseWithdraw}
          userData={userData}
          currencyName={currencyName}
          balance={currencyName == 'BNB' ? bnbBalance : maticzBalance}

        // handleShow={handleShowPair}
        />
      )}
    </>
  );
};

export default Vault;
